module.exports = __webpack_public_path__ + "img/4.91689336.png";